export function isTypingTarget(e: KeyboardEvent): boolean {
  const t = e.target
  if (!(t instanceof HTMLElement)) return false
  return (
    t.tagName === 'INPUT' ||
    t.tagName === 'TEXTAREA' ||
    t.tagName === 'SELECT' ||
    t.isContentEditable
  )
}

export interface ModeRequest {
  mode: 'buy' | 'sell'
  nonce: number
}

export function nextModeRequest(prev: ModeRequest | null, mode: 'buy' | 'sell'): ModeRequest {
  return { mode, nonce: (prev?.nonce ?? 0) + 1 }
}
